import ccpe from "../../images/certs/ccpe.png";
import bacp from "../../images/certs/bacp.png";
import ukcp from "../../images/certs/ukcp.png";
import pt from "../../images/certs/psycholog-today.png";
import { Link } from "react-router-dom";

function CertificationSection() {

    return (
        <section className="certification-section">
            <div className="certifications">
                <img src={ccpe} alt="ccpe" />
                <img src={bacp} alt="bacp" />
                <img src={ukcp} alt="ukcp" />
                <Link to="https://www.psychologytoday.com/gb/counselling/marc-lahaye-london/1609335"><img src={pt} alt="pt" /></Link>
            </div>
        </section>
    );
}

export default CertificationSection;